import { useEffect, useMemo, useState } from "react";
import { fetchBookedProjectsBatch, type BookedProjectDay } from "@/lib/employeeTimes";
import { groupBookedAssignmentSpans, type BookedAssignmentSpan } from "./bookedAssignments";
import { toIso } from "./dateUtils";

export function useBookedAssignments(
  days: Date[],
  employeeLogins: string[],
  enabled: boolean,
  isPlanned?: (login: string, iso: string, auftragId: number) => boolean,
): BookedAssignmentSpan[] {
  const [items, setItems] = useState<BookedProjectDay[]>([]);
  const from = days[0] ? toIso(days[0]) : "";
  const to = days.length ? toIso(days[days.length - 1]!) : "";
  const loginsKey = [...new Set(employeeLogins.map((login) => login.trim().toLowerCase()).filter(Boolean))]
    .sort()
    .join(",");

  useEffect(() => {
    if (!enabled || !from || !to || !loginsKey) {
      setItems([]);
      return;
    }
    let cancelled = false;
    void fetchBookedProjectsBatch({
      date_from: from,
      date_to: to,
      user_logins: loginsKey.split(","),
    })
      .then((result) => {
        if (!cancelled) setItems(result.items ?? []);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled, from, to, loginsKey]);

  return useMemo(
    () => groupBookedAssignmentSpans(items, isPlanned),
    [items, isPlanned],
  );
}
